import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListCustomer = (params) => sendGet("/customers", params);
export const createCustomer = (params) => sendPost("/customers", params);

export const updateCustomer = (id, params) =>
  sendPut(`/customers/${id}`, params);

export const deleteCustomer = (id) => sendDelete(`/customers/${id}`);
